import React, { useState } from 'react';
import { Edit, SimpleForm, TextInput, FileInput, ImageField, useUpdate, useNotify, useRedirect, Toolbar, SaveButton, required, useRecordContext } from 'react-admin';
import { RichTextInput } from 'ra-input-rich-text';
import { uploadImage } from '../../../config/services/strapi/strapi';
import { blocksToHtml, htmlToBlocks } from '../../../helpers/htmlUtils';

function NoticiasEdit() {
  const [update] = useUpdate();
  const redirect = useRedirect();
  const notify = useNotify();
  const resourceName = 'plg-noticiass';
  const record: any = useRecordContext();
  const [imageChanged, setImageChanged] = useState(false);
  const [imageDetalleChanged, setImageDetalleChanged] = useState(false);

  const handleSubmit = async (data: any) => {
    try {
      const token = localStorage.getItem('strapi_jwt');

      const payload: any = {
        anoImage: data.anoImage,
        slug: data.slug,
        descripcionImage: data.descripcionImage,
        descripcion: data.descripcion,
        descripcionDetalle: data.descripcionDetalle,
      };

      if (data.image?.rawFile) {
        const fileUploaded = await uploadImage(data.image.rawFile, token!);
        if (fileUploaded?.id) payload.image = { id: fileUploaded.id };
      }

      if (data.imageDetalle?.rawFile) {
        const fileDetalle = await uploadImage(data.imageDetalle.rawFile, token!);
        if (fileDetalle?.id) payload.imageDetalle = { id: fileDetalle.id };
      }

      await update(resourceName, { id: data.id || record.id, data: payload }, { returnPromise: true });
      notify('Noticia actualizada', { type: 'success' });
      redirect('list', resourceName);
    } catch (e: any) {
      notify(`Error: ${e.message}`, { type: 'error' });
    }
  };

  return (
    <Edit>
      <SimpleForm onSubmit={handleSubmit} toolbar={<Toolbar><SaveButton alwaysEnable /></Toolbar>}>
        <TextInput source="anoImage" validate={[required()]} fullWidth />
        <TextInput source="slug" validate={[required()]} fullWidth />

        <RichTextInput source="descripcionImage" label="Descripción breve" format={blocksToHtml} parse={htmlToBlocks} validate={[required()]} fullWidth />

        <RichTextInput source="descripcion" label="Descripción" format={blocksToHtml} parse={htmlToBlocks} fullWidth />
        <RichTextInput source="descripcionDetalle" label="Descripción detalle" format={blocksToHtml} parse={htmlToBlocks} fullWidth />

        {record?.image?.url && (
          <div>
            <div>
              <img src={record.image.url} alt="Imagen actual" style={{ width: 200, height: 'auto', borderRadius: 4 }} />
            </div>
          </div>
        )}

        <FileInput source="image" label="Subir nueva imagen (opcional)" multiple={false} onChange={() => setImageChanged(true)}>
          <>
            {imageChanged ? <ImageField source="src" title="title" /> : <ImageField source="url" title="title" />}
          </>
        </FileInput>

        {record?.imageDetalle?.url && (
          <div>
            <div>
              <img src={record.imageDetalle.url} alt="Imagen detalle actual" style={{ width: 200, height: 'auto', borderRadius: 4 }} />
            </div>
          </div>
        )}

        <FileInput source="imageDetalle" label="Subir nueva imagen detalle (opcional)" multiple={false} onChange={() => setImageDetalleChanged(true)}>
          <>
            {imageDetalleChanged ? <ImageField source="src" title="title" /> : <ImageField source="url" title="title" />}
          </>
        </FileInput>
      </SimpleForm>
    </Edit>
  );
}

export default NoticiasEdit;
